import type { Control, FieldPath, FieldValues } from "react-hook-form";

import type { AccountDetails } from "@/api/bank-query";

import { FormControl, FormField, FormItem, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface AccountNumberInputProps<T extends FieldValues> {
	name: FieldPath<T>;
	control: Control<T>;
	data: AccountDetails | undefined;
	isPending: boolean;
	isError: boolean;
	bankId: string;
}

export function AccountNumberInput<T extends FieldValues>({
	name,
	data,
	isError,
	control,
	bankId,
	isPending
}: AccountNumberInputProps<T>) {
	return (
		<FormField
			control={control}
			name={name}
			render={({ field }) => (
				<FormItem>
					<Label htmlFor={name} className="text-right">
						Account Number
					</Label>
					<FormControl>
						<Input
							{...field}
							id={name}
							min={1}
							type="number"
							placeholder="Enter Account Number"
							className="col-span-3 h-14"
						/>
					</FormControl>
					<FormMessage />

					{isPending && (
						<div className="text-sm animate-pulse bg-gray-200 p-2 rounded-lg capitalize">Loading...</div>
					)}
					{data && (
						<div className="text-sm text-green-800 bg-green-200 p-2 rounded-lg capitalize">
							{data?.accountName.toLowerCase()}
						</div>
					)}
					{bankId && field.value.length >= 10 && isError && (
						<div className="text-sm text-red-600 bg-red-200 p-2 rounded-lg capitalize">Account Not Found</div>
					)}
				</FormItem>
			)}
		/>
	);
}
